<template>
  <div>
    <child-dynamic-element
        v-for="element in elements"
        :element="{ conditionalValue: notEmptyValue, ...element }"
        :key="element.identifier"
        :formName="formName"
    />
  </div>
</template>

<script>
import {DynamicElement} from "formvue-json";

export default {
  name: "NotEmptyCondition",
  components: {
    "child-dynamic-element": DynamicElement,
  },
  props: {
    properties: {
      type: Object | Array,
      required: true,
    },
    elements: {
      type: Array,
    },
    formName: {
      type: String,
      required: true,
    },
  },
  computed: {
    notEmptyValue() {
      if (typeof this.properties?.checkField !== 'string') return null;

      const pattern = /^([a-zA-Z0-9_-]+)(?:\[([a-zA-Z0-9_-]+)])?$/;
      const matches = this.properties.checkField.match(pattern);
      if (!matches) return false;

      const field = matches[1];
      /** @type string */
      const arrayEntries = matches[2];

      const value = this.$store.getters.getCurrentInputValue(field);

      if (Array.isArray(value)) {
        if (!arrayEntries) return value.length > 0;  // not empty array

        // array contains arrayEntries
        const mustContain = arrayEntries.split(',');

        for (let key of mustContain) {
          if (!value.includes(key)) return false;
        }

        return true;
      } else {
        if (typeof value === 'string') return value.trim().length > 0;

        return (typeof value !== 'number' && !!value) || (typeof value === 'number' && !isNaN(value));
      }
    }
  },
};
</script>
